// eslint-disable-next-line no-restricted-imports
import moment, { type Moment } from "moment";
// eslint-disable-next-line no-restricted-imports -- chart helpers still use moment-range until PFF-576
import { DateRange } from "moment-range";
import { DateRangeOptions } from "@wayflyer/flyui";

import type { CustomTimeRange, TemporalResolution } from "./types";
import { TemporalResolutions } from "./types";

export const xDomain = (startDate: Moment, endDate: Moment, temporalResolution: TemporalResolution) => {
  const start = startDate.clone().startOf(temporalResolution.duration);
  const end = endDate.clone().startOf(temporalResolution.duration);
  return new DateRange(start, end);
};

export const xDomainSteps = (startDate: Moment, endDate: Moment, temporalResolution: TemporalResolution) => {
  return Array.from(xDomain(startDate, endDate, temporalResolution).by(temporalResolution.duration));
};

export const xFormatDate = (
  day: Moment,
  temporalResolution: TemporalResolution,
  firstDateInRange: Moment,
  lastDateInRange?: Moment
) => {
  let format = temporalResolution.xAxisLabelFormat;
  const lastDate = lastDateInRange ? lastDateInRange : moment();
  const daysDiff = lastDate.diff(firstDateInRange, "d");
  const gtYear = daysDiff > 365;
  format = temporalResolution.resolution === "WEEKLY" && gtYear ? "D MMM" : format;
  if ((temporalResolution.resolution === "MONTHLY" && !firstDateInRange.isSame(lastDate, "year")) || gtYear) {
    format += " Y";
  }
  return day.format(format);
};

export const dateForResolution = (date: Moment, temporalResolution: TemporalResolution) => {
  if (temporalResolution.resolution === TemporalResolutions.DAILY.resolution) {
    // Assume date is already correct
    return date;
  } else if (temporalResolution.resolution === TemporalResolutions.WEEKLY.resolution) {
    return date.clone().startOf("week");
  } else if (temporalResolution.resolution === TemporalResolutions.MONTHLY.resolution) {
    return date.clone().startOf("month");
  } else if (temporalResolution.resolution === TemporalResolutions.QUARTERLY.resolution) {
    return date.clone().startOf("quarter");
  }
};

export const precedingReferenceForTimeRange = (timeRange: CustomTimeRange) => {
  const daysDiff = timeRange.end.diff(timeRange.start, "d");
  const precedingEnd = timeRange.start.clone().subtract(1, "day");
  return {
    start: precedingEnd.clone().subtract(daysDiff, "d"),
    end: precedingEnd,
  };
};

export const yoyReferenceForTimeRange = (timeRange: CustomTimeRange, preset: DateRangeOptions) => {
  const isToDate = preset.indexOf("_TO_DATE") > -1;
  const start = timeRange.start.clone().subtract(1, "year");
  const end = timeRange.end.clone().subtract(1, "year");
  if (!isToDate) {
    return {
      start,
      end,
    };
  } else {
    const today = moment();
    return {
      start,
      end: moment({
        year: end.year(),
        month: today.month(),
        date: today.date(),
      }),
    };
  }
};

export const allHistoricalData = (timeRange: CustomTimeRange) => {
  return {
    start: timeRange.start.clone().subtract(5, "year"),
    end: timeRange.end,
  };
};
